import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminBillingSessions } from "../../api"


export const getAdminBillingData = createAsyncThunk('adminBilling/get-admin-billing-data', async (data) => {
    const { startDate, endDate } = data
    const res = await getAdminBillingSessions(startDate, endDate)
    return res.data
})
